import { IValidator, IValidations, ICartCourse, IStudentListCartItem } from '@/interfaces';

export class StudentListCartItemValidator implements IValidator<IStudentListCartItem> {
  public isValid(item: IStudentListCartItem) {
    const errors: IValidations<IStudentListCartItem> = {};

    if (!item.sessionId) errors.sessionId = [`${item.firstName} ${item.lastName} needs a session`];
    if (!item.priceTierId) errors.priceTierId = [`${item.firstName} ${item.lastName} needs a tier`];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}

export class CartCourseValidator implements IValidator<ICartCourse> {
  public isValid(item: ICartCourse) {
    const errors: IValidations<ICartCourse> = {};

    if (item.studentSessions.length === 0) errors.studentSessions = ['Student should be attached to a course'];

    const validator = new StudentListCartItemValidator();
    for (let i = 0; i < item.studentSessions.length && errors.studentSessions === undefined; ++i) {
      const result = validator.isValid(item.studentSessions[i]);
      if (result !== true) {
        errors.studentSessions = ['Students have errors'];
      }
    }
    return Object.keys(errors).length > 0 ? errors : true;
  }
}

